module.exports = __webpack_public_path__ + "static/shoes_02-a401f3ac4f54da99902d7cc28e66e7f2.png";